/**
 * The visitor's cookie-banner decision, shared by everything that needs
 * to know whether tracking is allowed.
 *
 * CookieConsent.tsx writes it; the lead form reads it to decide whether
 * to send Meta Conversions API context to our server. Keeping the key and
 * the parsing in one place stops the two from drifting apart — a mismatch
 * there would mean sending server-side conversions for someone who
 * declined.
 */

const STORAGE_KEY = 'inafana.cookie-consent';

export type ConsentDecision = 'accepted' | 'rejected';

export function readConsent(): ConsentDecision | null {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return v === 'accepted' || v === 'rejected' ? v : null;
  } catch {
    return null;
  }
}

export function writeConsent(decision: ConsentDecision): void {
  try {
    localStorage.setItem(STORAGE_KEY, decision);
  } catch {
    // localStorage unavailable (private browsing, full storage). The
    // banner will reappear next visit; that's the safest fallback.
  }
}

/** True only on an explicit accept — an undecided visitor is not consent. */
export function hasTrackingConsent(): boolean {
  return readConsent() === 'accepted';
}
